export class CloudBridgeConstants{
    constructor(){
        
    }
    readonly CLOUD_BRIDGE_BACKUP = {
        TOASTS:{
            BACKUP_STARTED:"Backup started successfully for ",
            BACKUP_STARTED_ERROR:"Backup could not be started! Please try again after some time.",
            TOGGLE_ENABLE_ERROR:"Backup enabling failed for  _storageType account _emailid due to some error. Please try later.",
            TOGGLE_DISABLE_ERROR:"Backup disabling failed for _storageType account _emailid due to some error. Please try later.",
            DISCONNECT_ERROR:"Account disconnect failed for _storageType account _emailid due to some error. Please try later.",
            RETRY_ERROR:"Retry Operation failed for _storageType account _emailid due to some error. Please try later.",
        }
    }
}

 